import { useState } from "react";
import { Eye, EyeOff } from "lucide-react";

const inputCls =
  "mt-2 w-full rounded-xl border border-line bg-white px-5 py-4 font-sans text-ink outline-none transition placeholder:text-ink-muted focus:border-bordeaux focus:ring-2 focus:ring-bordeaux/10";

export const Field = ({ label, testId, ...props }) => (
  <div>
    <label className="font-sans text-sm font-medium text-bordeaux-dark">{label}</label>
    <input data-testid={testId} required autoCapitalize="none" autoCorrect="off" spellCheck={false} className={inputCls} {...props} />
  </div>
);

export const PasswordField = ({ label, testId, ...props }) => {
  const [show, setShow] = useState(false);
  return (
    <div>
      <label className="font-sans text-sm font-medium text-bordeaux-dark">{label}</label>
      <div className="relative">
        <input data-testid={testId} required autoCapitalize="none" autoCorrect="off" spellCheck={false} type={show ? "text" : "password"} placeholder="••••••••" className={`${inputCls} pr-12`} {...props} />
        <button
          type="button"
          data-testid={`${testId}-toggle`}
          aria-label={show ? "Masquer le mot de passe" : "Afficher le mot de passe"}
          onClick={() => setShow((s) => !s)}
          className="absolute right-4 top-1/2 mt-1 -translate-y-1/2 text-ink-muted transition hover:text-bordeaux"
        >
          {show ? <EyeOff size={19} /> : <Eye size={19} />}
        </button>
      </div>
    </div>
  );
};

export const SubmitButton = ({ children, loading, testId }) => (
  <button
    data-testid={testId}
    type="submit"
    disabled={loading}
    className="w-full rounded-full bg-bordeaux py-4 font-sans text-base font-medium text-white transition hover:bg-bordeaux-dark disabled:opacity-60"
  >
    {loading ? "Un instant…" : children}
  </button>
);

export const FormMessage = ({ error, success }) =>
  error ? (
    <p data-testid="form-error" className="rounded-xl bg-bordeaux/5 px-4 py-3 text-center font-sans text-sm text-bordeaux">{error}</p>
  ) : success ? (
    <p data-testid="form-success" className="rounded-xl bg-white px-4 py-3 text-center font-sans text-sm text-bordeaux-dark border border-line">{success}</p>
  ) : null;
